














import { Vue, Component, Prop } from 'vue-property-decorator';

import { Surface } from '@/components/atoms';
import CloseIcon from '@/components/icons/CloseTipIcon.vue';
import eventBus from '@/utils/eventBus';
import PlanOverview, {
  TLocationAction
} from '../LocationFormModal/Steps/PlanOverview.vue';

@Component({
  components: {
    Surface,
    CloseIcon,
    PlanOverview
  }
})
export default class BillingLocationUpdatedModal extends Vue {
  @Prop({ default: 'delete' }) action!: TLocationAction;
  @Prop() subscription!: any;

  onClose() {
    eventBus.$emit('closeModal');
  }
}
